import { useSteps, StepLayoutChildProps, Step } from '@consigli/facade';
import { StructuralType } from '@consigli/types';
import { FC, useState } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PackageForm } from '../components/package-form';
import { StructuralUploadInfo } from '../components/upload-info-panel';
import { UserUpload } from '../components/user-upload';
import { TabType, WizardLayout } from '../components/wizard-layout';
import { useCreatePackageUtil } from '../hooks/use-create-package';
import { useUploadProgress } from '../hooks/use-upload-progress';

interface StructuralWizardProps {
  userInput: JSX.Element;
}
export const StructuralWizard = ({ userInput }: StructuralWizardProps) => {
  const [formData, setFormData] = useState<FieldValues>({
    iterationName: '',
    inputType: '',
  });
  const { t } = useTranslation();
  const [localFiles, setLocalFiles] = useState<File[]>([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [targetCounter, setTargetCounter] = useState(0);
  const [currentCounter, setCurrentCounter] = useState(0);
  const { onAnalyze: onProcess } = useCreatePackageUtil({ setTargetCounter, setCurrentCounter });
  const { isUploading, progress } = useUploadProgress(currentCounter, targetCounter);

  const onAnalyze = async () => {
    setIsProcessing(true);
    await onProcess(localFiles, formData, StructuralType.STRUCTURAL);
    setIsProcessing(false);
  };

  const { withStep, StepIndicator, StepOutlet, useStepContext } = useSteps(
    (step: (name: string, component: FC<StepLayoutChildProps>) => Step) => {
      return [
        step(t('package-creation.information'), () => (
          <PackageForm context={useStepContext} setFormData={setFormData} formData={formData}>
            {userInput}
          </PackageForm>
        )),
        step(t('package-creation.upload'), () => (
          <UserUpload
            localFiles={localFiles}
            setLocalFiles={setLocalFiles}
            useStepContext={useStepContext}
            onAnalyze={onAnalyze}
          ></UserUpload>
        )),
      ];
    },
  );

  const CreateOptimizationPackageForm = () => {
    const StepComponent = withStep(() => {
      return (
        <>
          <StepIndicator />
          <StepOutlet />
        </>
      );
    });

    return StepComponent;
  };

  const messageHeader = <StructuralUploadInfo />;

  return (
    <WizardLayout
      isProcessing={isProcessing}
      messageHeader={messageHeader}
      isUploading={isUploading}
      progress={progress}
      tabContent={{
        [TabType.CREATE_PACKAGE]: <CreateOptimizationPackageForm />,
      }}
    />
  );
};
